import React, { useEffect, useState } from "react";
import { Transfer } from "antd";
import useRoles from "hooks/access-control/useRoles";

export default function AssignRoleToUser({
  assignedRoles,
  disabled,
  onRolesChange,
}) {
  const { roles } = useRoles();
  const [data, setData] = useState([]);
  const [targetRoles, setTargetRoles] = useState([]); // store assigned roles
  const [originalAssignedIds, setOriginalAssignedIds] = useState([]); // to filter out already assigned ids

  // convert roles to required format
  useEffect(() => {
    if (!roles || roles.length === 0) return;

    const formatted = roles.map((p) => ({
      key: p.id.toString(),
      title: p.name,
      description: p.description || p.name,
    }));

    setData(formatted);
  }, [roles]);

  // pre-select user assigned roles
  useEffect(() => {
    if (!assignedRoles) return;

    const selected = assignedRoles.map((p) => p.id.toString());
    setTargetRoles(selected);
    setOriginalAssignedIds(selected);
  }, [assignedRoles]);

  const filterOption = (inputValue, option) =>
    option.title.toLowerCase().includes(inputValue.toLowerCase()) ||
    option.description.toLowerCase().includes(inputValue.toLowerCase());

  const handleChange = (newTargetRoles) => {
    if (disabled) return;
    setTargetRoles(newTargetRoles);

    // identify only new roles added by user
    const addedRoles = newTargetRoles.filter(
      (id) => !originalAssignedIds.includes(id),
    );

    // identify only roles removed by user
    const removedRoles = originalAssignedIds.filter(
      (id) => !newTargetRoles.includes(id),
    );

    // pass selected roles to parent component
    onRolesChange?.({ added: addedRoles, removed: removedRoles });
  };

  return (
    <Transfer
      dataSource={data}
      showSearch
      filterOption={filterOption}
      targetKeys={targetRoles}
      onChange={handleChange}
      render={(item) => item.title}
      titles={["Available Roles", "Assigned Roles"]}
      disabled={disabled}
    />
  );
}
